import useSWRImmutable from 'swr/immutable';

import useConfig from '@/hooks/useConfig.ts';

import { DataCurPracUser } from '@/models/data-cur/DataCurPracUser.ts';
import { DCUser } from '@/models/doc-cirrus/DCUser.ts';

import { getUsersFromMultipleInstances } from '@/services/practitionersService.ts';

import { getCustomerId } from '@/utils/customer-utils.ts';

interface PvsPractitionersHook {
    instance_users_map?: Record<string, DCUser | DataCurPracUser>;
    getPvsPractitionersFromInstance: (instance_id: string) => DCUser[];
}

const usePvsPractitioners = (): PvsPractitionersHook => {
    const { configs, selected_location } = useConfig();

    const { data } = useSWRImmutable(
        {
            key: 'users',
            customer_id: getCustomerId(),
            location: selected_location.key,
        },
        () => getUsersFromMultipleInstances(configs)
    );

    const getPvsPractitionersFromInstance = (instance_id: string): DCUser[] => {
        if (!data) return [];

        const practitioners: DCUser[] = [];
        for (const key in data) {
            if (key.startsWith(instance_id)) {
                practitioners.push(data[key] as DCUser);
            }
        }

        return practitioners;
    };

    return { instance_users_map: data, getPvsPractitionersFromInstance: getPvsPractitionersFromInstance };
};

export default usePvsPractitioners;
